{
  "name": "beaming",
  "author": "Kyle Florence",
  "description": "A browser-based puzzle game that involves directing beams through a hexagonal grid.",
  "version": "1.0.0",
  "license": "CC BY-NC 4.0",
  "main": "src/electron/main.js",
  "type": "module",
  "targets": {
    "web": {
      "context": "browser",
      "source": "src/index.html"
    },
    "electron": {
      "context": "electron-renderer",
      "source": "src/electron/preload.js"
    },
    "main": false
  },
  "browserslist": [
    "defaults"
  ],
  "config": {
    "detect_chromedriver_version": true
  },
  "engines": {
    "node": ">=18"
  },
  "eslintConfig": {
    "env": {
      "browser": true
    },
    "globals": {
      "doorbell": false
    }
  },
  "scripts": {
    "build": "parcel build --public-url=.",
    "build:electron": "parcel build --target=electron",
    "build:web": "parcel build --target=web --public-url=.",
    "clean": "rm -rf .parcel-cache dist out",
    "desktop": "npm run clean && cross-env TARGET=electron npm run build && electron-forge start -- -- --debug",
    "make": "npm run clean && cross-env TARGET=electron npm run build && electron-forge make",
    "package": "npm run clean && cross-env TARGET=electron npm run build && electron-forge package",
    "start": "parcel --target=web",
    "test": "npm run test:lint && npm run test:functional",
    "test:functional": "mocha test --recursive --timeout 20000",
    "test:lint": "standard"
  },
  "devDependencies": {
    "@electron-forge/cli": "^7.11.1",
    "@electron-forge/maker-base": "^7.11.1",
    "@electron-forge/maker-deb": "^7.11.1",
    "@electron-forge/maker-zip": "^7.11.1",
    "@electron-forge/plugin-fuses": "^7.11.1",
    "@electron/fuses": "^1.8.0",
    "@parcel/optimizer-htmlnano": "^2.16.4",
    "@parcel/resolver-glob": "^2.16.4",
    "app-builder-lib": "^26.8.1",
    "chromedriver": "^147.0.4",
    "cross-env": "^10.1.0",
    "electron": "^41.1.1",
    "mocha": "^11.7.5",
    "parcel": "^2.16.4",
    "path-browserify": "^1.0.1",
    "process": "^0.11.10",
    "selenium-webdriver": "^4.41.0",
    "standard": "^17.1.2",
    "svgo": "^4.0.1",
    "wait-on": "^9.0.4"
  },
  "dependencies": {
    "@fontsource-variable/noto-sans-mono": "^5.2.10",
    "@json-editor/json-editor": "^2.15.2",
    "@phosphor-icons/web": "^2.1.2",
    "@types/chroma-js": "^3.1.2",
    "chroma-js": "^3.2.0",
    "deepmerge": "^4.3.1",
    "electron-log": "^5.4.3",
    "electron-store": "^11.0.2",
    "jsondiffpatch": "0.7.3",
    "pako": "^2.1.0",
    "paper": "^0.12.18",
    "steamworks-ffi-node": "^0.10.2",
    "tippy.js": "^6.3.7"
  },
  "overrides": {
    "@tootallnate/once": "^3.0.1",
    "diff": "^8.0.3",
    "serialize-javascript": "^7.0.5",
    "tar": "^7.5.10",
    "tmp": "^0.2.4"
  }
}
